<template>

		<div class="border" :style="style"><slot></slot></div>
</template>
<script>
	export default{
		name:"Border",
		props:{
			style:{type:String}
		}
	}
</script>



// WEBPACK FOOTER //
// Border.vue?6a922a91